import { useEffect } from 'react';
import Api from '../services/Api';
import { AUTH_TOKEN_NAME } from '../controllers/AutenticacaoController';

/** Um minuto. O servidor considera a sessão morta com 5 de silêncio (configurável em
 *  ACESSO_CONFIG.sessao_inatividade_min), então há folga de sobra para uma rede ruim
 *  engolir quatro batidas seguidas antes de alguém ser derrubado por engano. */
const INTERVALO_MS = 60_000;

/**
 * Mantém a sessão viva enquanto a pessoa está com o sistema aberto.
 *
 * POR QUE PRECISA EXISTIR
 *
 * O servidor marca o sinal de vida a cada requisição — então quem está clicando nunca
 * expira. O problema é a tela aberta parada: a pessoa volta do almoço, clica, e descobre
 * que foi deslogada. Pior: até a sessão expirar, ela também não consegue entrar de outra
 * máquina, porque o sistema ainda a vê logada.
 *
 * O QUE ELE NÃO FAZ
 *
 * Não trata erro. Se o ping voltar 401, quem age é o interceptador do Api.ts, que já leva
 * para o login com a explicação. Duplicar esse tratamento aqui criaria dois caminhos para
 * a mesma coisa, e eles divergiriam.
 *
 * Só bate se houver token: na tela de login não há sessão a manter, e chamar sem token
 * produziria 401 e um redirecionamento em cima de quem já está no login.
 */
export function useSessaoPing() {
  useEffect(() => {
    const bater = () => {
      try {
        if (!localStorage.getItem(AUTH_TOKEN_NAME)) return;
      } catch {
        return;
      }

      Api.get('api/sessao/Ping').catch(() => {
        // O Api.ts cuida do 401. Qualquer outra falha é rede, e a próxima batida resolve.
      });
    };

    const id = setInterval(bater, INTERVALO_MS);

    return () => clearInterval(id);
  }, []);
}
